import React from 'react';
import './combo-products.scss';
import PropTypes from 'prop-types';
import ComboCard from './ComboCard';
import { Link } from 'react-router-dom';

const ComboProducts = props => {
  const {
    title,
    products,
    info,
    moreInfo = 'KNOW MORE',
    moreInfoActionUrl,
    showSoldOut = true,
    minDealsCount = 0,
    source = '',
  } = props;
  let filteredProducts = products;
  if (!showSoldOut) {
    filteredProducts = products?.filter(p => p.skus[0].isInventoryAvailable);
  }
  return (
    <React.Fragment>
      {filteredProducts?.length >= minDealsCount && (
        <div className="combo-deals">
          {title && (
            <div className="combo-deals--title vxl-section-title">{title}</div>
          )}
          {info && (
            <div className="combo-deals--more-info">
              <div className="combo-deals--more-info--info">{info}</div>
              <Link to={moreInfoActionUrl} className="button action-link more">
                {moreInfo}
              </Link>
            </div>
          )}
          <div className="combo-deals--container">
            {filteredProducts?.map(p => (
              <ComboCard product={p} key={p.comboProductId} source={source} />
            ))}
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

ComboProducts.propTypes = {
  title: PropTypes.string,
  products: PropTypes.array.isRequired,
  info: PropTypes.string,
  moreInfo: PropTypes.string,
  moreInfoActionUrl: PropTypes.string,
  showSoldOut: PropTypes.bool,
  minDealsCount: PropTypes.number,
  source: PropTypes.string,
};

export default ComboProducts;
